/** The references object of all modules needed for components initialization */
var references = {
    /** Page module references */
    'product': require('./pages/product'),
    'searchsuggest': require('./searchsuggest'),
    'common-elements': require('./common-elements'),
    'backToTop': require('./components/common/BackToTop').default,
    'newsletterForm': require('./components/forms/NewsletterForm').default,
    'dialog': require('./components/common/Dialog').default,
    'checkout': require('../js/pages/checkout'),

    /** Components from extension cartridge */
    'iframeVideo': require('./../../../app_storefront_core_ext/cartridge/js/components/common/IFrameVideo').default,
    'emailme': require('./pages/product/emailme'),
    'productMainImageNav': require('./../../../app_storefront_core_ext/cartridge/js/components/product/ProductMainImageNav').default,

    /** Components */
    'zoom': require('./components/common/zoom'),
    'productTileCmp': require('./components/common/productTileCmp').default,

    /** Checkout */
    'checkoutCustom': require('./components/checkout/CustomCheckout'),
    'shippingFormsContainer': require('./components/checkout/shipping/shippingForms/Container').default,
    'shipping': require('./components/checkout/shipping/Shipping').default,
    'stickyElement': require('./components/common/StickyElement'),
    'slickSlider': require('./components/common/SlickSlider'),
    'header': require('./header'),
    'cart': require('./pages/cart'),
    'minicart': require('./minicart'),
    'variant': require('./pages/product/variant'),
    'addToCart': require('./pages/product/addToCart'),
    'headerNavigationContainer': require('./components/header/HeaderNavigation').default,
    'headerContainer': require('./components/header/Header').default,
    /** PLP */
    'plp': require('./components/plp/Plp').default,
    'refinement': require('./components/plp/refinements/Refinement').default,
    'refinementsContainer': require('./components/plp/refinements/Container').default,
    'productList': require('./components/plp/productList/ProductList').default,
    'productTile': require('./components/plp/productTile/ProductTile').default,
    'quickShop': require('./components/plp/productTile/quickShop/QuickShop').default,
    'notifyMe': require('./components/plp/notifyMe/NotifyMe').default,
    /** PDP */
    'pdp': require('./../../../app_storefront_core_ext/cartridge/js/components/pdp/Pdp').default,
    'pdpVideos': require('./../../../app_storefront_core_ext/cartridge/js/components/pdp/pdpVideos/PdpVideos').default,
    /** Checkout Login */
    'checkoutLogin': require('./pages/checkout/checkoutLogin'),
	/** Checkout Components */
    /** Shipping */
	'bpostShippingForm': require('./components/checkout/shipping/shippingForms/Bpostshippingforms').default,
    'sendingShippingForm': require('./components/checkout/shipping/shippingForms/Sendingshippingforms').default,
    'dhlShippingForm': require('./components/checkout/shipping/shippingForms/DHLShippingForms').default,
    'seurShippingForm': require('./components/checkout/shipping/shippingForms/seurShippingForms').default,

    /**Order Confirmation */
    'registeraccount': require('./components/registeraccount')
};

/** The components initialization configuration object */
var configuration = {
    'global' : {
        'components': {
            'slickSlider': {},
            'productTileCmp': {},
            'productTile': {},
            'quickShop': {},
            'header': {},
            'variant': {},
            'addToCart': {},
            'emailme': {}
        }
    },
    'cart': {},
    'checkout': {
        'components': {
            'checkoutCustom': {},
			'bpostShippingForm': {},
            'sendingShippingForm': {},
            'dhlShippingForm': {},
            'seurShippingForm' : {}
        }
    },
    'search' : {
        'components': {
            'productTileCmp': {},
            'emailme': {}
        }
    },
    'orderconfirmation':{
        'components':{
            'registeraccount': {}
        }
    },
    'product': {
        'components': {
            'pdp': {},
            'pdpVideos': {},
            'iframeVideo': {},
            'productMainImageNav': {enabled: false},
            'productTileCmp': {},
            'productTile': {},
            'quickShop': {}
        }
    },
    'checkoutlogin': {
        'components': {
            'checkoutLogin': {},
        }
    }
};

module.exports = {
    'configuration' : configuration,
    'references' : references
};